<template>
	<div>
		<template v-if="!submitCompleted">
			<p class="ui-title">Reset password</p>
			<p class="ui-body">Request password reset link by email</p>
			<ui-form
				:is-processing="isProcessing"
				:valid.sync="formValid"
				@submit="forgotPassword"
			>
				<ui-input
					v-model="email"
					label="E-mail"
					required
					type="email"
				/>
				<div class="ui-layout ui-alignment-center-space-between">
					<router-link :to="{name: 'Login'}">Back to login</router-link>
					<ui-button
						:disabled="!formValid || isProcessing"
						primary
						raised
						text="Submit"
						type="submit"
					/>
				</div>
			</ui-form>
		</template>

		<p v-else class="ui-body" v-html="forgotSuccessBody"></p>
	</div>
</template>

<script>
import UiButton from "lib/components/ui/Button";
import UiForm from "lib/components/ui/Form";
import UiInput from "lib/components/ui/Input";
import http from "lib/modules/Http";
import alert from "lib/modules/Alert";

export default {
	name: "ForgotPassword",
	components: {
		UiButton,
		UiForm,
		UiInput
	},
	props: {
		forgotSuccessBody: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			formValid: false,
			isProcessing: false,
			email: "",
			submitCompleted: false
		};
	},
	mounted() {
		this.$el.querySelector("input").focus();
	},
	methods: {
		forgotPassword() {
			this.isProcessing = true;

			http.post("/api/v2/user/forgotpassword", { email: this.email })
			.then(() => {
				this.submitCompleted = true;
			})
			.catch((error) => {
				alert.error("Forgot password request failed", error.response);
			})
			.finally(() => {
				this.isProcessing = false;
			});
		}
	}
};
</script>
